import { dateUtility } from "../../../../common/infrastructure/utilities/dateUtility";
import { IPlannerEventUserCurrentPlanModel } from "../models/plannerEventUserCurrentPlanModel";

export interface IPlanLabel {
  text: string;
  isExpired: boolean;
}

/**
 * The client's plan as a short line after their name on the attendee row:
 * "План 12 · 3 бр. · до 08.12" ("План 12 · до 08.12" when unlimited). A plan that ran out
 * says why: "изчерпан" (no visits left) or "изтекъл на 06.10".
 */
export const getPlanLabel = (
  plan?: IPlannerEventUserCurrentPlanModel | null,
): IPlanLabel | undefined => {
  if (!plan) {
    return undefined;
  }

  const until = dateUtility.formatDate(plan.activeUntil, "dd.MM");
  const isUnlimited =
    plan.remainingVisits === null || plan.remainingVisits === undefined;

  let details: string;
  if (plan.isExpired) {
    details =
      !isUnlimited && plan.remainingVisits! <= 0
        ? "изчерпан"
        : `изтекъл на ${until}`;
  } else {
    details = isUnlimited
      ? `до ${until}`
      : `${plan.remainingVisits} бр. · до ${until}`;
  }

  return { text: `${plan.name} · ${details}`, isExpired: plan.isExpired };
};
